<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="2">
                    <input type="text" v-model="searchUniversal" placeholder="Cari" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchJenis" class="form-control" v-model="searchJenis" placeholder="Jenis Surat"></model-select>
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchMasalah" class="form-control" v-model="searchMasalah" placeholder="Kode Klasifikasi"></model-select>
                </CCol>
                <CCol sm="2">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="dateStart" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <input type="text" onfocus="(this.type='date')" :disabled="dateStart==''" :min="dateStart" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="dateEnd" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6">
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" @disposition="dispositionData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <!-- <CModal
            size="lg"
            :centered="true"
            title="Disposition"
            color="white"
            :show.sync="dispositionModal"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Disposition</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="dispositionModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <CRow style="padding-right:20px;padding-left:20px">
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <label class="mb-2">
                                    Tambah Disposition
                                </label>
                                <div class="autocomplete">
                                    <input type="text"
                                            class="form-control"
                                            @click="toggleVisiblePeserta()"
                                            @blur="toggleCloseVisiblePeserta()"
                                            v-model="queryPeserta"
                                            v-text="selectedItemPeserta ? selectedItemPeserta['text'] : ''"
                                            @keydown.up="upPeserta"
                                            @keydown.down="downPeserta"
                                            @keydown.enter="selectItemPeserta"
                                            placeholder="Pilih Peserta"
                                    >
                                    <div class="popovers" v-show="visiblePeserta">
                                        <div class="options" v-if="matchesPeserta.length != 0 && queryPeserta.length != 0" ref="optionsList">
                                            <ul>
                                            <li v-for="(match, index) in matchesPeserta"
                                                :key="index"
                                                :class="{ 'selected': (selectedPeserta == index)}"
                                                @click="itemClickedPeserta(index)"
                                                v-text="match['text']"></li>
                                            </ul>
                                        </div>
                                        <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length != 0">
                                            Data Tidak Ditemukan
                                        </div>
                                        <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length == 0">
                                            Start Typing...
                                        </div>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mt-4" v-if="sumPeserta.length != 0">
                            <CCol sm="12">
                                <label class="mb-2">
                                    Daftar Disposition
                                </label>
                                <CRow v-for="(li, id) in sumPeserta" :key="id">
                                    <CCol sm="1">
                                        {{id+1}}.
                                    </CCol>
                                    <CCol sm="10">
                                        {{li.nama}}
                                    </CCol>
                                    <CCol sm="1">
                                        <img :src="closeIcon" @click="deleteSum(id)" style="cursor:pointer" width="10px" height="10px"/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6">
                        <CRow>
                            <CCol sm="12">
                                <label class="mb-2">
                                    Action
                                </label>
                                <CRow v-for="(li, id) in dataAksi" :key="id">
                                    <CCol sm="1 pt-1">
                                        <input type="checkbox" :id="li.unix" :name="li.action" class="form-control">
                                    </CCol>
                                    <CCol sm="11">
                                        <label :for="li.unix">{{li.action}}</label>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow class="mt-3" style="padding-bottom:40px;padding-left:20px;padding-right:20px" v-if="errDisposition != ''">
                    <CCol sm="12">
                        <span class="text-danger">
                            {{errDisposition}}
                        </span>
                    </CCol>
                </CRow>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="6"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="dispositionModal = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                    <CCol sm="3">
                        <CButton @click="goSaveDisposition()" class="w-100" color="primary">Simpan</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal> -->
    </div>
    <div v-else class="area-edit">
        <!-- <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            >
            <p>Apakah anda yakin ingin menghapus data?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal> -->
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CTabs variant="tabs" :active-tab="activeTab">
                    <CTab disabled class="mt-2">
                        <template #title>
                            <span>Input Data</span>
                        </template>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <CRow class="mb-2">
                                    <CCol sm="12">
                                        <span class="font-weight-bold" style="font-size: 16px;color:black">Detail Surat</span>
                                    </CCol>
                                </CRow>
                                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                                <CRow class="mt-3">
                                    <CCol sm="6">
                                        <label>Jenis Surat</label>
                                        <model-select :options="dataJenis"
                                            :isDisabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;opacity:1!important'"
                                            class="form-control model-select"
                                            v-model.trim="$v.jenis.$model"
                                            :class="{ 'is-invalid select-invalid':$v.jenis.$error, 'is-valid select-valid': !$v.jenis.$invalid }"
                                            placeholder="Pilih Jenis Surat">
                                        </model-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <label>Kode Klasifikasi</label>
                                        <model-select :options="dataMasalah"
                                            :isDisabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;opacity:1!important'"
                                            class="form-control model-select"
                                            v-model.trim="$v.masalah.$model"
                                            :class="{ 'is-invalid select-invalid':$v.masalah.$error, 'is-valid select-valid': !$v.masalah.$invalid }"
                                            placeholder="Pilih Kode Klasifikasi">
                                        </model-select>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="6">
                                        <label>Dari</label>
                                        <div class="autocomplete">
                                            <input type="text"
                                                class="form-control"
                                                v-if="tipe!='R'"
                                                @click="toggleVisibleDari()"
                                                @blur="toggleCloseVisibleDari()"
                                                :class="{ 'is-invalid':$v.queryDari.$error, 'is-valid': !$v.queryDari.$invalid }"
                                                v-model.trim="$v.queryDari.$model"
                                                v-text="selectedItemDari ? selectedItemDari['text'] : ''"
                                                @keydown.up="upDari"
                                                @keydown.down="downDari"
                                                @keydown.enter="selectItemDari"
                                                placeholder="Dari"
                                            >
                                            <input type="text"
                                                class="form-control"
                                                v-else
                                                disabled
                                                style="background-color:whitesmoke;color:black!important"
                                                :class="{ 'is-invalid':$v.queryDari.$error, 'is-valid': !$v.queryDari.$invalid }"
                                                v-model.trim="$v.queryDari.$model"
                                                v-text="selectedItemDari ? selectedItemDari['text'] : ''"
                                                @keydown.up="upDari"
                                                @keydown.down="downDari"
                                                @keydown.enter="selectItemDari"
                                                placeholder="Dari"
                                            >
                                            <div class="popovers" v-show="visibleDari">
                                                <div class="options" v-if="matchesDari.length != 0 && queryDari.length != 0" ref="optionsList">
                                                    <ul>
                                                    <li v-for="(match, index) in matchesDari"
                                                        :key="index"
                                                        :class="{ 'selected': (selectedDari == index)}"
                                                        @click="itemClickedDari(index)"
                                                        v-text="match['text']"></li>
                                                    </ul>
                                                </div>
                                                <div class="options" v-if="matchesDari.length == 0 && queryDari.length != 0">
                                                    Data Tidak Ditemukan
                                                </div>
                                                <div class="options" v-if="matchesDari.length == 0 && queryDari.length == 0">
                                                    Start Typing...
                                                </div>
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="3">
                                        <label>Kepada</label>
                                        <div class="autocomplete">
                                            <input type="text"
                                                v-if="tipe != 'R'"
                                                class="form-control"
                                                @click="toggleVisibleKepada()"
                                                @blur="toggleCloseVisibleKepada()"
                                                :class="classKepada"
                                                v-model="queryKepada"
                                                v-text="selectedItemKepada ? selectedItemKepada['text'] : ''"
                                                @keydown.up="upKepada"
                                                @keydown.down="downKepada"
                                                v-on:keyup.enter="selectItemKepada('click')"
                                                placeholder="Kepada"
                                            >
                                            <input type="text"
                                                v-else
                                                disabled
                                                style="background-color:whitesmoke;color:black!important"
                                                class="form-control"
                                                :class="classKepada"
                                                v-model="queryKepada"
                                                v-text="selectedItemKepada ? selectedItemKepada['text'] : ''"
                                                @keydown.up="upKepada"
                                                @keydown.down="downKepada"
                                                placeholder="Kepada"
                                            >
                                            <div class="popovers" v-show="visibleKepada">
                                                <div class="options" v-if="matchesKepada.length != 0 && queryKepada.length != 0" ref="optionsList">
                                                    <ul>
                                                    <li v-for="(match, index) in matchesKepada"
                                                        :key="index"
                                                        :class="{ 'selected': (selectedKepada == index)}"
                                                        @click="itemClickedKepada(index)"
                                                        v-text="match"></li>
                                                    </ul>
                                                </div>
                                                <div class="options" v-if="matchesKepada.length == 0 && queryKepada.length != 0">
                                                    Tekan enter untuk menambahkan
                                                </div>
                                                <div class="options" v-if="matchesKepada.length == 0 && queryKepada.length == 0">
                                                    Start Typing...
                                                </div>
                                            </div>
                                        </div>
                                    </CCol>
                                    <CCol sm="3">
                                        <label v-if="tempKepada.length != 0">Daftar Kepada:</label>
                                        <ul class="list-group" v-if="tempKepada.length != 0">
                                            <li class="list-group-item" v-for="(li,id) in tempKepada" :key="id">
                                                <CRow>
                                                    <CCol sm="10"><span style="font-size:11px">{{li}}</span></CCol>
                                                    <CCol v-if="tipe!='R'" sm="2"><img :src="closeIcon" class="mt-2" style="cursor:pointer;float:right" @click="removeKepada(id)" width="11px" height="11px"/></CCol>
                                                </CRow>
                                            </li>
                                        </ul>
                                    </CCol>
                                    <CCol sm="6">
                                        <label>Alamat surat yang dituju</label>
                                        <input 
                                            class="form-control"
                                            :disabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;color:black'"
                                            v-model.trim="$v.alamatKepada.$model"
                                            :class="{ 'is-invalid':$v.alamatKepada.$error, 'is-valid': !$v.alamatKepada.$invalid }"
                                            placeholder="example: Ditempat"
                                            type="text"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="6">
                                        <label>Tempat Pembuatan Surat</label>
                                        <model-select :options="dataTempat"
                                            class="form-control model-select"
                                            :isDisabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;opacity:1!important'"
                                            v-model.trim="$v.tempat.$model"
                                            :class="{ 'is-invalid select-invalid':$v.tempat.$error, 'is-valid select-valid': !$v.tempat.$invalid }"
                                            placeholder="Pilih Tempat">
                                        </model-select>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="6">
                                        <label>Sifat Surat</label>
                                        <model-select :options="dataSifat"
                                            class="form-control model-select"
                                            :isDisabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;opacity:1!important'"
                                            v-model.trim="$v.sifat.$model"
                                            :class="{ 'is-invalid select-invalid':$v.sifat.$error, 'is-valid select-valid': !$v.sifat.$invalid }"
                                            placeholder="Pilih Sifat Surat">
                                        </model-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <label>Lampiran</label>
                                        <model-select :options="dataLampiran"
                                            class="form-control model-select"
                                            :isDisabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;opacity:1!important'"
                                            v-model="lampiran"
                                            placeholder="Pilih Lampiran">
                                        </model-select>
                                    </CCol>
                                </CRow>
                                <CRow v-if="lampiran.value != ''">
                                    <CCol sm="6">
                                    </CCol>
                                    <CCol sm="6">
                                        <label>Jumlah {{lampiran.text}}</label>
                                        <input 
                                            v-model="jumlah"
                                            :disabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;color:black'"
                                            class="form-control"
                                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                                            placeholder="Jumlah" 
                                            type="text"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="6">
                                        <label>Perihal</label>
                                        <textarea 
                                            class="form-control" 
                                            :disabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;color:black!important'"
                                            v-model.trim="$v.perihal.$model"
                                            :class="{ 'is-invalid':$v.perihal.$error, 'is-valid': !$v.perihal.$invalid }"
                                            placeholder="Perihal"
                                            type="text"
                                        />
                                    </CCol>
                                    <CCol sm="3">
                                        <label>Tembusan</label>
                                        <input 
                                            v-model="namaTembusan"
                                            :disabled="tipe=='R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke;color:black'"
                                            :class="classTembusan"
                                            class="form-control"
                                            placeholder="Tulis Nama kemudian tekan Enter" 
                                            v-on:keyup.enter="enterTembusan"
                                            type="text"
                                        />
                                    </CCol>
                                    <CCol sm="3" v-if="tempTembusan.length != 0">
                                        <label>Daftar Tembusan:</label>
                                        <ul class="list-group">
                                            <li class="list-group-item" v-for="(li,id) in tempTembusan" :key="id">
                                                <CRow>
                                                    <CCol sm="10"><span style="font-size:11px">{{li}}</span></CCol>
                                                    <CCol v-if="tipe!='R'" sm="2"><img :src="closeIcon" style="cursor:pointer;float:right" @click="removeTembusan(id)" width="11px" height="11px"/></CCol>
                                                </CRow>
                                            </li>
                                        </ul>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <CRow class="mb-2">
                                    <CCol sm="12">
                                        <span class="font-weight-bold" style="font-size: 16px;color:black">Reviewer</span>
                                    </CCol>
                                </CRow>
                                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                                <CRow class="mt-3">
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="6">
                                                <label>Reviewer 1</label>
                                                <div class="autocomplete">
                                                    <input type="text"
                                                            class="form-control"
                                                            v-if="tipe!='R'"
                                                            @click="toggleVisibleReviewer1()"
                                                            @blur="toggleCloseVisibleReviewer1()"
                                                            v-model="queryReviewer1"
                                                            v-text="selectedItemReviewer1 ? selectedItemReviewer1['text'] : ''"
                                                            @keydown.up="upReviewer1"
                                                            @keydown.down="downReviewer1"
                                                            @keydown.enter="selectItemReviewer1"
                                                            placeholder="Reviewer 1"
                                                    >
                                                    <input type="text"
                                                            class="form-control"
                                                            v-else
                                                            disabled
                                                            style="background-color:whitesmoke;color:black!important"
                                                            v-model="queryReviewer1"
                                                            v-text="selectedItemReviewer1 ? selectedItemReviewer1['text'] : ''"
                                                            @keydown.up="upReviewer1"
                                                            @keydown.down="downReviewer1"
                                                            @keydown.enter="selectItemReviewer1"
                                                            placeholder="Reviewer 1"
                                                    >
                                                    <div class="popovers" v-show="visibleReviewer1">
                                                        <div class="options" v-if="matchesReviewer1.length != 0 && queryReviewer1.length != 0" ref="optionsList">
                                                            <ul>
                                                            <li v-for="(match, index) in matchesReviewer1"
                                                                :key="index"
                                                                :class="{ 'selected': (selectedReviewer1 == index)}"
                                                                @click="itemClickedReviewer1(index)"
                                                                v-text="match['text']"></li>
                                                            </ul>
                                                        </div>
                                                        <div class="options" v-if="matchesReviewer1.length == 0 && queryReviewer1.length != 0">
                                                            Data Tidak Ditemukan
                                                        </div>
                                                        <div class="options" v-if="matchesReviewer1.length == 0 && queryReviewer1.length == 0">
                                                            Start Typing...
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="6">
                                                <label>Reviewer 2</label>
                                                <div class="autocomplete">
                                                    <input type="text"
                                                            class="form-control"
                                                            v-if="tipe!='R'"
                                                            @click="toggleVisibleReviewer2()"
                                                            @blur="toggleCloseVisibleReviewer2()"
                                                            v-model="queryReviewer2"
                                                            v-text="selectedItemReviewer2 ? selectedItemReviewer2['text'] : ''"
                                                            @keydown.up="upReviewer2"
                                                            @keydown.down="downReviewer2"
                                                            @keydown.enter="selectItemReviewer2"
                                                            placeholder="Reviewer 2"
                                                    >
                                                    <input type="text"
                                                            class="form-control"
                                                            v-else
                                                            disabled
                                                            style="background-color:whitesmoke;color:black!important"
                                                            v-model="queryReviewer2"
                                                            v-text="selectedItemReviewer2 ? selectedItemReviewer2['text'] : ''"
                                                            @keydown.up="upReviewer2"
                                                            @keydown.down="downReviewer2"
                                                            @keydown.enter="selectItemReviewer2"
                                                            placeholder="Reviewer 2"
                                                    >
                                                    <div class="popovers" v-show="visibleReviewer2">
                                                        <div class="options" v-if="matchesReviewer2.length != 0 && queryReviewer2.length != 0" ref="optionsList">
                                                            <ul>
                                                            <li v-for="(match, index) in matchesReviewer2"
                                                                :key="index"
                                                                :class="{ 'selected': (selectedReviewer2 == index)}"
                                                                @click="itemClickedReviewer2(index)"
                                                                v-text="match['text']"></li>
                                                            </ul>
                                                        </div>
                                                        <div class="options" v-if="matchesReviewer2.length == 0 && queryReviewer2.length != 0">
                                                            Data Tidak Ditemukan
                                                        </div>
                                                        <div class="options" v-if="matchesReviewer2.length == 0 && queryReviewer2.length == 0">
                                                            Start Typing...
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="6">
                                                <label>Reviewer 3</label>
                                                <div class="autocomplete">
                                                    <input type="text"
                                                            class="form-control"
                                                            v-if="tipe!='R'"
                                                            @click="toggleVisibleReviewer3()"
                                                            @blur="toggleCloseVisibleReviewer3()"
                                                            v-model="queryReviewer3"
                                                            v-text="selectedItemReviewer3 ? selectedItemReviewer3['text'] : ''"
                                                            @keydown.up="upReviewer3"
                                                            @keydown.down="downReviewer3"
                                                            @keydown.enter="selectItemReviewer3"
                                                            placeholder="Reviewer 3"
                                                    >
                                                    <input type="text"
                                                            class="form-control"
                                                            v-else
                                                            disabled
                                                            style="background-color:whitesmoke;color:black!important"
                                                            v-model="queryReviewer3"
                                                            v-text="selectedItemReviewer3 ? selectedItemReviewer3['text'] : ''"
                                                            @keydown.up="upReviewer3"
                                                            @keydown.down="downReviewer3"
                                                            @keydown.enter="selectItemReviewer3"
                                                            placeholder="Reviewer 3"
                                                    >
                                                    <div class="popovers" v-show="visibleReviewer3">
                                                        <div class="options" v-if="matchesReviewer3.length != 0 && queryReviewer3.length != 0" ref="optionsList">
                                                            <ul>
                                                            <li v-for="(match, index) in matchesReviewer3"
                                                                :key="index"
                                                                :class="{ 'selected': (selectedReviewer3 == index)}"
                                                                @click="itemClickedReviewer3(index)"
                                                                v-text="match['text']"></li>
                                                            </ul>
                                                        </div>
                                                        <div class="options" v-if="matchesReviewer3.length == 0 && queryReviewer3.length != 0">
                                                            Data Tidak Ditemukan
                                                        </div>
                                                        <div class="options" v-if="matchesReviewer3.length == 0 && queryReviewer3.length == 0">
                                                            Start Typing...
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <CRow class="mb-2">
                                    <CCol sm="12">
                                        <span class="font-weight-bold" style="font-size: 16px;color:black">Isi Surat</span>
                                    </CCol>
                                </CRow>
                                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                                <CRow class="mt-3">
                                    <CCol sm="12">
                                        <vue-editor 
                                            :editorToolbar="customToolbar"
                                            :disabled="tipe == 'R'"
                                            :style="tipe=='R'&&'background-color:whitesmoke'"
                                            v-model.trim="$v.isi.$model"
                                            :class="{ 'is-invalid select-invalid':$v.isi.$error, 'is-valid select-valid': !$v.isi.$invalid }"
                                            :placeholder="tipe!='R'&&'Masukkan Isi Surat'"
                                        ></vue-editor>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-5">
                            <CCol sm="12 text-right">
                                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Kembali</CButton>
                                <CButton @click="checkTab" class="btn btn-edit-submit">
                                    <span>Selanjutnya</span>
                                </CButton>
                            </CCol>
                        </CRow>
                    </CTab>
                    <CTab disabled class="mt-2">
                        <template #title>
                            <span>Attachment</span>
                        </template>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <CRow class="mb-2">
                                    <CCol sm="12">
                                        <span class="font-weight-bold" style="font-size: 16px;color:black">Attachment</span>
                                    </CCol>
                                </CRow>
                                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                                <CRow v-if="tipe!='R'" class="mt-3">
                                    <CCol sm="12">
                                        <label>Deskripsi Dokumen</label>
                                        <textarea 
                                            class="form-control" 
                                            v-model="deskripsi"
                                            placeholder="Deskripsi"
                                            type="text"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow v-if="tipe!='R'" class="mt-3">
                                    <CCol sm="12">
                                        <label>Upload Dokumen (*Max file 5 MB, *Max Attachment 20MB)</label>
                                        <div>
                                        <CButton v-if="file == '' || file == null" type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih Dokumen</CButton>
                                        <input type="file" accept=".pdf, .PDF, .doc, .docx, .xls, .xlsx" @change="loadFile()" style="display:none"  id="inputFile" class="hide" />
                                        </div>
                                        <!--  -->
                                        <p v-if="file != '' && file != null" class="font-weight-bold"><span class="mr-3">{{fileName}}</span><CButton class="mr-2" @click="removeFile()" color="danger">Hapus</CButton><CButton @click="uploadFile" color="secondary">Upload Dokumen</CButton></p>
                                    </CCol>
                                </CRow>
                                <CRow class="mt-3" v-if="tempFile.length != 0">
                                    <CCol sm="12">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>File Name</th>
                                                    <th>File Size (Byte)</th>
                                                    <th>Deskripsi</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(file, id) in tempFile" :key="id">
                                                    <td style="max-width: 400px;">{{file.fileName}}</td>
                                                    <td>{{file.size}}</td>
                                                    <td>{{file.deskripsi}}</td>
                                                    <td>
                                                        <CButton @click="showFile(id)" class="mr-2" color="secondary">Lihat</CButton>
                                                        <CButton v-if="tipe!='R'" @click="deleteFile(id)" color="danger">Hapus</CButton>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </CCol>
                                </CRow>
                                <CRow v-if="tempFile.length == 0">
                                    <CCol sm="12">
                                        <span>File Kosong</span>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-5">
                            <CCol sm="12 text-right">
                                <CButton @click="activeTab = 0" class="btn btn-edit-submit mr-2">Sebelumnya</CButton>
                                <CButton @click="activeTab = 2" class="btn btn-edit-submit">Selanjutnya</CButton>
                            </CCol>
                        </CRow>
                    </CTab>
                    <CTab disabled class="mt-2" v-if="tipe == 'R'">
                        <template #title>
                            <span>Riwayat</span>
                        </template>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <CRow class="mb-2">
                                    <CCol sm="12">
                                        <span class="font-weight-bold" style="font-size: 16px;color:black">Riwayat Surat</span>
                                    </CCol>
                                </CRow>
                                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                                <CRow class="mt-5 mb-5">
                                    <CCol sm="12">
                                        <ul class="StepProgress">
                                            <li class="StepProgress-item" v-for="(item, index) in track" :key="'track'+index" :class="[item.action != 'S' ? 'is-done' : '']">
                                                <div class="font-weight-bold">{{item.nama_Approve_By}}</div>
                                                <div>
                                                    <span v-if="item.action == 'C'" class="text-primary font-weight-bold">{{item.keterangan_Action}}</span>
                                                    <span v-if="item.action == 'R'" class="text-danger font-weight-bold">{{item.keterangan_Action}}</span>
                                                    <span v-if="item.action == 'S'" class="text-success font-weight-bold">{{item.keterangan_Action}}</span>
                                                    <span v-if="item.action == 'A'" class="text-info font-weight-bold">{{item.keterangan_Action}}</span>
                                                    <span v-if="item.action == 'W'" class="text-warning font-weight-bold">{{item.keterangan_Action}}</span>
                                                    {{item.reviewer_Ke}} <span v-if="item.tanggal.length != 0">at {{item.tanggal}}</span>
                                                </div>
                                                <div>{{item.keterangan}}</div>
                                            </li>
                                        </ul>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-5">
                            <CCol sm="12 text-right">
                                <CButton @click="activeTab = 1" class="btn btn-edit-submit mr-2">Sebelumnya</CButton>
                                <CButton @click="activeTab = 3" class="btn btn-edit-submit">Selanjutnya</CButton>
                            </CCol>
                        </CRow>
                    </CTab>
                    <CTab disabled class="mt-2">
                        <template #title>
                            <span>Surat</span>
                        </template>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <CRow class="mb-2">
                                    <CCol sm="12">
                                        <span class="font-weight-bold" style="font-size: 16px;color:black">Lihat Surat</span>
                                    </CCol>
                                </CRow>
                                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                                <CRow class="mt-3">
                                    <CCol sm="6">
                                        <label>Lihat Surat - QR Code (.pdf)</label>
                                        <div>
                                            <CButton
                                                @click="showSurat('1')"
                                                color='info'
                                                size='sm'
                                                variant='outline'
                                                className="m-2"
                                                class="w-25"
                                            >Lihat</CButton>
                                        </div>
                                    </CCol>
                                    <CCol sm="6">
                                        <label>Lihat Surat - Signature (.pdf)</label>
                                        <div>
                                            <CButton
                                                @click="showSurat(null)"
                                                color='info'
                                                size='sm'
                                                variant='outline'
                                                className="m-2"
                                                class="w-25"
                                            >Lihat</CButton>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow class="mt-5">
                            <CCol sm="12 text-right">
                                <CButton v-if="tipe != 'R'" @click="activeTab = 1" class="btn btn-edit-submit mr-2">Sebelumnya</CButton>
                                <CButton v-if="tipe == 'R'" @click="activeTab = 2" class="btn btn-edit-submit mr-2">Sebelumnya</CButton>
                                <CButton v-if="tipe != 'R'" @click="submitForm('D')" class="btn btn-cancel mr-2">Draft</CButton>
                                <CButton v-if="tipe != 'R'" @click="submitForm('S')" class="btn btn-cancel">Simpan</CButton>
                                <CButton v-if="tipe == 'R'" @click="moving()" class="btn btn-cancel">Kembali</CButton>
                            </CCol>
                        </CRow>
                    </CTab>
                </CTabs>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '@/component/tableIBC'
import { DataApi, DataApiUpload } from "@/service/DataApi";
import { required } from 'vuelidate/lib/validators'
import { ModelSelect } from 'vue-search-select'
import { validationMixin } from 'vuelidate'
import { VueEditor } from "vue2-editor";
export default {
    components: {
        Tables,
        ModelSelect,
        VueEditor
    },
    mixins: [validationMixin],
    validations: {
        jenis: {
            text: {
                required
            },
            value: {
                required
            }
        },
        masalah: {
            text: {
                required
            },
            value: {
                required
            }
        },
        tempat: {
            text: {
                required
            },
            value: {
                required
            }
        },
        sifat: {
            text: {
                required
            },
            value: {
                required
            }
        },
        queryDari: {
            required
        },
        tempKepada: {
            required
        },
        perihal: {
            required
        },
        isi: {
            required
        },
        komentar: {
            required
        },
        alamatKepada: {
            required
        }
    },
    data() {
        return {
            track: [],
            success: true,
            activeTab: 0,
            refreshIcon: require('@/assets/menu/icon_refresh.svg'),
            moreIcon: require('@/assets/menu/icon_more.svg'),
            closeIcon: require('@/assets/menu/icon_close.svg'),
            backIcon: require('@/assets/menu/icon_goback.svg'),
            dataTh: ['Dari', 'Subjek', 'Klasifikasi', 'Dibuat', 'Action'],
            dataTd: ['namaDari', 'Subjek', 'masalah', 'createdDate', 'dispositions'],
            styleTable: ['175px', '300px', '100px', '100px', '200px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }, { background: [] }],
                ["link"],
            ],

            // data model
            dataJenis: [],
            dataMasalah: [],
            dataTempat: [],
            dataSifat: [],
            dataLampiran: [],
            jenis: {
                text: '',
                value: ''
            },
            masalah: {
                text: '',
                value: ''
            },
            tempat: {
                text: '',
                value: ''
            },
            sifat: {
                text: '',
                value: ''
            },
            lampiran: {
                text: '',
                value: ''
            },
            tipe: 'C',

            // data dari
            dataDari: [],
            titleDari:"Dari",
            selectedItemDari: null,
            selectedDari: 0,
            queryDari: '',
            visibleDari: false,
            idDari: '',

            // data kepada
            dataKepada: [],
            titleKepada:"Kepada",
            selectedItemKepada: null,
            selectedKepada: 0,
            queryKepada: '',
            visibleKepada: false,

            alamatKepada: '',

            // data tembusan
            namaTembusan: '',

            perihal: '',
            jumlah: '',

            // data reviewer1
            dataReviewer1: [],
            titleReviewer1:"Reviewer 1",
            selectedItemReviewer1: null,
            selectedReviewer1: 0,
            queryReviewer1: '',
            visibleReviewer1: false,
            idReviewer1: '',

            // data reviewer2
            dataReviewer2: [],
            titleReviewer2:"Reviewer 2",
            selectedItemReviewer2: null,
            selectedReviewer2: 0,
            queryReviewer2: '',
            visibleReviewer2: false,
            idReviewer2: '',

            // data reviewer3
            dataReviewer3: [],
            titleReviewer3:"Reviewer 3",
            selectedItemReviewer3: null,
            selectedReviewer3: 0,
            queryReviewer3: '',
            visibleReviewer3: false,
            idReviewer3: '',

            isi: '',
            komentar: '',

            file: '',
            fileName: '',
            fileSize: '',
            urlFile: '',
            tempFile: [],
            unix: '',

            keteranganApprove: '',
            nomorSurat: '',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchUniversal: '',
            dataSearchJenis: [],
            searchJenis: {
                value: '',
                text: ''
            },
            dataSearchMasalah: [],
            searchMasalah: {
                value: '',
                text: ''
            },
            dateStart: '',
            dateEnd: '',
            
            // datas
            datas: [],
            tempKepada: [],
            tempTembusan: [],
            classKepada: '',

            //error
            errorMessage: '',

            // delete
            deleteModal: false,

            dispositionModal: false,
            dataAksi: [],
            kodeSurat: '',

            // data peserta
            dataPeserta: [],
            titlePeserta:"Pilih Peserta",
            selectedItemPeserta: null,
            selectedPeserta: 0,
            queryPeserta: '',
            visiblePeserta: false,
            idPeserta: '',
            sumPeserta: [],
            errDisposition: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchUniversal() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
            this.classKepada = ''
        },
        queryDari() {
            this.getDataDari('null')
        },
        queryKepada() {
            this.getDataKepada()
        },
        tempKepada() {
            if(this.tempKepada.length == 0) {
                this.classKepada = 'is-invalid'
            } else {
                this.classKepada = 'is-valid'
            }
        },
        queryReviewer1() {
            this.getDataReviewer1('null')
        },
        queryReviewer2() {
            this.getDataReviewer2('null')
        },
        queryReviewer3() {
            this.getDataReviewer3('null')
        },
        activeTab() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPeserta() {
            if(this.queryPeserta == '') {
                this.idPeserta = ''
            }
            this.getDataPeserta()
        },
        dispositionModal() {
            if(this.dispositionModal == false) {
                this.errDisposition = ''
                this.sumPeserta = []
                this.kodeSurat = ''
                this.dataAksi = []
                this.getDataAksi()
            }
        },
        lampiran() {
            if(this.lampiran.value == '') {
                this.jumlah = ''
            }
        }
    },
    methods: {
        checkTab() {
            this.activeTab = 1
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kodeMasalah.toLowerCase() < b.kodeMasalah.toLowerCase()) {
                        return -1
                    }
                    if (a.kodeMasalah.toLowerCase() > b.kodeMasalah.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.masalah.toLowerCase() < b.masalah.toLowerCase()) {
                        return -1
                    }
                    if (a.masalah.toLowerCase() > b.masalah.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDataSearchMasalah() {
            let payload = {
                kodeMasalah: "",
                limit: 9999,
                pageIn: 1,
                masalah: ""
            }
            DataApi.post("surat/masalah/lihat", payload)
            .then(res => {
                this.dataSearchMasalah = [{
                    value: '',
                    text: 'Semua Klasifikasi'
                }]
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].kodeMasalah + ' - ' + temp[i].masalah
                        }
                        this.dataSearchMasalah.push(onPush)
                    }
                } else {
                    this.dataSearchMasalah = []
                }
            })
        },
        getDataSearchJenis() {
            let payload = {
                internal: "0",
                jenis: "",
                kodeJenis: "",
                limit: 9999,
                pageIn: 1
            }
            DataApi.post("surat/jenis/lihat", payload)
            .then(res => {
                this.dataSearchJenis = [{
                    value: '',
                    text: 'Semua Jenis Surat'
                }]
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].kodeJenis + ' - ' + temp[i].jenis
                        }
                        this.dataSearchJenis.push(onPush)
                    }
                } else {
                    this.dataSearchJenis = []
                }
            })
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page
            let searchUniversal = this.searchUniversal

            let payload = {
                filterUniversal: searchUniversal,
                isiSurat: "",
                jenisSurat: this.searchJenis.value,
                limit: limit,
                masalah: this.searchMasalah.value,
                namaDari: "",
                namaKepada: "",
                namaOnReview: "",
                nomorSurat: "",
                pageIn: page,
                perihal: "",
                sifatSurat: "",
                status: "",
                tanggalSuratDari: this.dateStart,
                tanggalSuratKe: this.dateEnd,
                tempatSurat: "",
                tipe: "S",
                internal: '0'
            }
            DataApi.post("surat/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchUniversal = ''
            this.flagSearch
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.tempKepada = []
                this.tempTembusan = []
                this.dataJenis = []
                this.dataMasalah = []
                this.dataTempat = []
                this.dataSifat = []
                this.dataLampiran = []
                this.jenis.text = ''
                this.jenis.value = ''
                this.masalah.text = ''
                this.masalah.value = ''
                this.tempat.text = ''
                this.tempat.value = ''
                this.sifat.text = ''
                this.sifat.value = ''
                this.lampiran.text = ''
                this.lampiran.value = ''
                this.dataDari = []
                this.titleDari = "Dari"
                this.selectedItemDari = null
                this.selectedDari = 0
                this.queryDari = ''
                this.visibleDari = false
                this.idDari = ''
                this.alamatKepada = ''
                this.perihal = ''
                this.jumlah = ''
                this.dataReviewer1 = []
                this.titleReviewer1 ="Reviewer 1"
                this.selectedItemReviewer1 = null
                this.selectedReviewer1 = 0
                this.queryReviewer1 = ''
                this.visibleReviewer1 = false
                this.idReviewer1 = ''
                this.dataReviewer2 = []
                this.titleReviewer2 ="Reviewer 2"
                this.selectedItemReviewer2 = null
                this.selectedReviewer2 = 0
                this.queryReviewer2 = ''
                this.visibleReviewer2 = false
                this.idReviewer2 = ''
                this.dataReviewer3 = []
                this.titleReviewer3 ="Reviewer 3"
                this.selectedItemReviewer3 = null
                this.selectedReviewer3 = 0
                this.queryReviewer3 = ''
                this.visibleReviewer3 = false
                this.idReviewer3 = ''
                this.isi = ''
                this.komentar = ''
                this.file = ''
                this.fileName = ''
                this.fileSize = ''
                this.urlFile = ''
                this.tempFile = []
                this.unix = ''
                this.keteranganApprove = ''
                this.tipe = 'C'
                this.activeTab = 0
                this.nomorSurat = ''

                this.dataKepada = []
                this.titleKepada ="Kepada"
                this.selectedItemKepada = null
                this.selectedKepada = 0
                this.queryKepada = ''
                this.visibleKepada = false
                this.namaTembusan = ''
                
                
                this.getDataJenis()
                this.getDataMasalah()
                this.getDataTempat()
                this.getDataLampiran()
                this.getDataSifat()
                this.getDataKepada()
                this.getDataDari('null')
                this.getDataReviewer1('null')
                this.getDataReviewer2('null')
                this.getDataReviewer3('null')
                this.classKepada = ''
                this.$v.$reset()
                this.getData()
            }
        },
        goSave(val) {
            let listReviewer = []
            
            if(this.idReviewer1 != '') {
                listReviewer.push(this.idReviewer1)
            }
            if(this.idReviewer2 != '') {
                listReviewer.push(this.idReviewer2)
            }
            if(this.idReviewer3 != '') {
                listReviewer.push(this.idReviewer3)
            }

            let payload = {
                alamatKepada: this.alamatKepada,
                action: val,
                dari: this.idDari,
                isiSurat: this.isi,
                jenisLampiran: this.lampiran.value,
                jumlahLampiran: this.jumlah,
                keteranganApprove: this.keteranganApprove,
                kodeJenisSurat: this.jenis.value,
                kodeMasalah: this.masalah.value,
                komentar: this.komentar,
                listKepada: this.tempKepada,
                listLampiran: this.tempFile,
                listReviewer: listReviewer,
                listTembusan: this.tempTembusan,
                perihal: this.perihal,
                sifatSurat: this.sifat.value,
                tempatSurat: this.tempat.value,
                tipe: this.tipe,
                unix: this.unix
            }
            DataApi.post("surat/simpan", payload)
            .then(res => {
                this.deleteModal = false
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            let dataJenis = this.dataJenis
            let dataMasalah = this.dataMasalah
            let dataTempat = this.dataTempat
            let dataLampiran = this.dataLampiran
            let dataSifat = this.dataSifat
            let jenis = generate.idJenisSurat
            let masalah = generate.kodeMasalah
            let tempat = generate.tempatSurat
            let lampiran = generate.jenisLampiran
            let sifat = generate.sifatSurat
            let review = generate.listReviewer
            var i,j,k,l,m,n
            for(i=0;i<dataJenis.length;i++) {
                if(dataJenis[i].value == jenis) {
                    this.jenis.value = dataJenis[i].value
                    this.jenis.text = dataJenis[i].text
                }
            }
            for(j=0;j<dataMasalah.length;j++) {
                if(dataMasalah[j].value == masalah) {
                    this.masalah.value = dataMasalah[j].value
                    this.masalah.text = dataMasalah[j].text
                }
            }
            for(k=0;k<dataTempat.length;k++) {
                if(dataTempat[k].value == tempat) {
                    this.tempat.value = dataTempat[k].value
                    this.tempat.text = dataTempat[k].text
                }
            }
            for(l=0;l<dataLampiran.length;l++) {
                if(dataLampiran[l].value == lampiran) {
                    this.lampiran.value = dataLampiran[l].value
                    this.lampiran.text = dataLampiran[l].text
                }
            }
            for(m=0;m<dataSifat.length;m++) {
                if(dataSifat[m].value == sifat) {
                    this.sifat.value = dataSifat[m].value
                    this.sifat.text = dataSifat[m].text
                }
            }
            this.getDataDari(generate.idDari)
            
            let tembusan = []
            if(generate.listTembusan == null) {
                tembusan = []
            } else {
                tembusan = generate.listTembusan
            }

            var p
            this.tempTembusan = []
            for(p=0;p<tembusan.length;p++) {
                this.tempTembusan.push(tembusan[p].nama)
            }

            let kepada = []
            if(generate.listKepada == null) {
                kepada = []
            } else {
                kepada = generate.listKepada
            }

            var q
            this.tempKepada = []
            for(q=0;q<kepada.length;q++) {
                this.tempKepada.push(kepada[q].nama)
            }

            if(generate.listLampiran == null) {
                this.tempFile = []
            } else {
                this.tempFile = generate.listLampiran
            }

            if(review != null) {
                if(review[0] != undefined) {
                    this.getDataReviewer1(review[0].id)
                }
                if(review[1] != undefined) {
                    this.getDataReviewer2(review[1].id)
                }
                if(review[2] != undefined) {
                    this.getDataReviewer3(review[2].id)
                }
            }

            this.isi = generate.isiSuratHtml
            this.jumlah = generate.jumlahLampiran
            this.komentar = generate.komentar
            this.perihal = generate.perihal

            this.unix = generate.unix
            if(generate.action == 'D') {
                this.tipe = 'U'
            }
            if(generate.action == 'S') {
                this.tipe = 'R'
            }

            this.track = generate.listHistory
            this.nomorSurat = generate.nomorSurat
            
            this.moving()
        },
        showSurat(val) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: this.unix,
                qr: val
            }
            DataApi.post("/export/surat/lihat", payload , {responseType: 'blob'})
            .then(res => {
                this.$store.state.loadingScreen = false
                let response = res.data
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                const link = document.createElement('a')
                link.href = url
                let title = this.jenis.text + ' - ' + this.perihal
                link.setAttribute('download', title)
                document.body.appendChild(link)
                link.click()
            })
        },

        /**
         * VALIDATION DATA
         */
        submitForm(val) {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.tempKepada.length == 0) {
                    this.classKepada = 'is-invalid'
                }
                alert("Harap melengkapi pengisian form terlebih dahulu.")
            } else {
                if(this.tempFile.length == this.jumlah) {
                    this.goSave(val)
                    this.loading = true
                } else {
                    alert("Maaf, Jumlah " + this.lampiran.text + ' tidak sesuai dengan dokumen yang di unggah.')
                }
            }
        },
        getDataJenis() {
            let payload = {
                kodeJenis: "",
                limit: 9999,
                pageIn: 1,
                jenis: "",
                internal: '0'
            }
            DataApi.post("surat/jenis/lihat", payload)
            .then(res => {
                this.dataJenis = []
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].kodeJenis + ' - ' + temp[i].jenis
                        }
                        this.dataJenis.push(onPush)
                    }
                } else {
                    this.dataJenis = []
                }
            })
        },
        getDataMasalah() {
            let payload = {
                kodeMasalah: "",
                limit: 9999,
                pageIn: 1,
                masalah: ""
            }
            DataApi.post("surat/masalah/lihat", payload)
            .then(res => {
                this.dataMasalah = []
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].kodeMasalah + ' - ' + temp[i].masalah
                        }
                        this.dataMasalah.push(onPush)
                    }
                } else {
                    this.dataMasalah = []
                }
            })
        },
        getDataTempat() {
            let payload = {
                kodeTempat: "",
                limit: 9999,
                pageIn: 1,
                tempat: ""
            }
            DataApi.post("surat/tempat/lihat", payload)
            .then(res => {
                this.dataTempat = []
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].tempat,
                            text: temp[i].kodeTempat + ' - ' + temp[i].tempat
                        }
                        this.dataTempat.push(onPush)
                    }
                } else {
                    this.dataTempat = []
                }
            })
        },
        getDataLampiran() {
            this.dataLampiran = [
                { value: '', text: 'None' },
                { value: 'Lembar', text: 'Lembar' },
                { value: 'Dokumen', text: 'Dokumen' },
                { value: 'Berkas', text: 'Berkas' }
            ]
        },
        getDataSifat() {
            this.dataSifat = [
                { value: 'Biasa', text: 'Biasa' },
                { value: 'Segera', text: 'Segera' },
                { value: 'Sangat Segera', text: 'Sangat Segera' }
            ]
        },

        /**
         * SEARCH SELECT DARI
         */
        getDataDari(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    idPegawai: '',
                    limit: 10,
                    nama: this.queryDari,
                    pageIn: 1
                }
            } else {
                payload = {
                    idPegawai: val,
                    limit: 10,
                    nama: '',
                    pageIn: 1
                }
            }
            DataApi.post("pegawai/get/jabatan", payload)
            .then(res => {
                this.dataDari = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i][0],
                        text: tempData[i][1]
                    }
                    this.dataDari.push(onPush)
                }
                if(val != 'null') {
                    this.queryDari = this.dataDari[0].text
                    this.idDari = this.dataDari[0].value
                }
            })
        },
        toggleVisibleDari() {
            this.visibleDari = true;
        },
        hideDari() {
            this.visibleDari = false;
        },
        toggleCloseVisibleDari() {
            setTimeout(this.hideDari, 1000);
        },
        itemClickedDari(index) {
            this.selectedDari = index;
            this.selectItemDari();
        },
        selectItemDari() {
            if (!this.matchesDari.length) {
            return;
            }
            this.selectedItemDari = this.matchesDari[this.selectedDari];
            this.visibleDari = false;
            this.queryDari = this.selectedItemDari.text
            this.idDari = this.selectedItemDari.value
            if (this.shouldReset) {
            this.queryDari = '';
            this.selectedDari = 0;
            }
        },
        upDari() {
            if (this.selectedDari == 0) {
            return;
            }
            this.selectedDari -= 1;
            this.scrollToItemDari();
        },
        downDari() {
            if (this.selectedDari >= this.matchesDari.length - 1) {
            return;
            }
            this.selectedDari += 1;
            this.scrollToItemDari();
        },
        scrollToItemDari() {
            this.$refs.optionsList.scrollTop = this.selectedDari * this.itemHeight;
        },

        /**
         * SEARCH SELECT KEPADA
         */
         getDataKepada() {
            let payload = {
                limit: 10,
                nama: this.queryKepada,
                pageIn: 1
            }
            DataApi.post("surat/eksternal/kontak", payload)
            .then(res => {
                this.dataKepada = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    this.dataKepada.push(tempData[i])
                }
            })
        },
        toggleVisibleKepada() {
            this.visibleKepada = true;
        },
        hideKepada() {
            this.visibleKepada = false;
        },
        toggleCloseVisibleKepada() {
            setTimeout(this.hideKepada, 1000);
        },
        itemClickedKepada(index) {
            this.selectedKepada = index;
            this.selectItemKepada();
        },
        selectItemKepada(val) {
            let namePush = ''
            if(val == 'click') {
                namePush = this.queryKepada
            } else {
                namePush = this.matchesKepada[this.selectedKepada]
            }
            this.visibleKepada = false;
            
            let data = this.tempKepada
            if(data.length == 0) {
                this.tempKepada.push(namePush)
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j].toLowerCase() == namePush.toLowerCase()) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    this.tempKepada.push(namePush)
                }
            }
            this.queryKepada = ''
            if (this.shouldReset) {
            this.queryKepada = '';
            this.selectedKepada = 0;
            }
        },
        upKepada() {
            if (this.selectedKepada == 0) {
            return;
            }
            this.selectedKepada -= 1;
            this.scrollToItemKepada();
        },
        downKepada() {
            if (this.selectedKepada >= this.matchesKepada.length - 1) {
            return;
            }
            this.selectedKepada += 1;
            this.scrollToItemKepada();
        },
        scrollToItemKepada() {
            this.$refs.optionsList.scrollTop = this.selectedKepada * this.itemHeight;
        },
        removeKepada(id) {
            this.tempKepada.splice(id, 1)
        },


        /**
         * SEARCH SELECT TEMBUSAN
         */
         enterTembusan() {
            let data = this.tempTembusan
            let push = this.namaTembusan
            if(data.length == 0) {
                this.tempTembusan.push(push)
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j] == push) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    this.tempTembusan.push(push)
                }
            }
            this.namaTembusan = ''
        },
        removeTembusan(id) {
            this.tempTembusan.splice(id, 1)
        },

        /**
         * SEARCH SELECT REVIEWER 1
         */
        getDataReviewer1(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    idPegawai: '',
                    limit: 10,
                    nama: this.queryReviewer1,
                    pageIn: 1
                }
            } else {
                payload = {
                    idPegawai: val,
                    limit: 10,
                    nama: '',
                    pageIn: 1
                }
            }
            DataApi.post("pegawai/get/jabatan", payload)
            .then(res => {
                this.dataReviewer1 = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i][0],
                        text: tempData[i][1]
                    }
                    this.dataReviewer1.push(onPush)
                }
                if(val != 'null') {
                    this.queryReviewer1 = this.dataReviewer1[0].text
                    this.idReviewer1 = this.dataReviewer1[0].value
                }
            })
        },
        toggleVisibleReviewer1() {
            this.visibleReviewer1 = true;
        },
        hideReviewer1() {
            this.visibleReviewer1 = false;
        },
        toggleCloseVisibleReviewer1() {
            setTimeout(this.hideReviewer1, 1000);
        },
        itemClickedReviewer1(index) {
            this.selectedReviewer1 = index;
            this.selectItemReviewer1();
        },
        selectItemReviewer1() {
            if (!this.matchesReviewer1.length) {
            return;
            }
            this.selectedItemReviewer1 = this.matchesReviewer1[this.selectedReviewer1];
            this.visibleReviewer1 = false;
            this.queryReviewer1 = this.selectedItemReviewer1.text
            this.idReviewer1 = this.selectedItemReviewer1.value
            if (this.shouldReset) {
            this.queryReviewer1 = '';
            this.selectedReviewer1 = 0;
            }
        },
        upReviewer1() {
            if (this.selectedReviewer1 == 0) {
            return;
            }
            this.selectedReviewer1 -= 1;
            this.scrollToItemReviewer1();
        },
        downReviewer1() {
            if (this.selectedReviewer1 >= this.matchesReviewer1.length - 1) {
            return;
            }
            this.selectedReviewer1 += 1;
            this.scrollToItemReviewer1();
        },
        scrollToItemReviewer1() {
            this.$refs.optionsList.scrollTop = this.selectedReviewer1 * this.itemHeight;
        },

        /**
         * SEARCH SELECT REVIEWER 2
         */
        getDataReviewer2(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    idPegawai: '',
                    limit: 10,
                    nama: this.queryReviewer2,
                    pageIn: 1
                }
            } else {
                payload = {
                    idPegawai: val,
                    limit: 10,
                    nama: '',
                    pageIn: 1
                }
            }
            DataApi.post("pegawai/get/jabatan", payload)
            .then(res => {
                this.dataReviewer2 = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i][0],
                        text: tempData[i][1]
                    }
                    this.dataReviewer2.push(onPush)
                }
                if(val != 'null') {
                    this.queryReviewer2 = this.dataReviewer2[0].text
                    this.idReviewer2 = this.dataReviewer2[0].value
                }
            })
        },
        toggleVisibleReviewer2() {
            this.visibleReviewer2 = true;
        },
        hideReviewer2() {
            this.visibleReviewer2 = false;
        },
        toggleCloseVisibleReviewer2() {
            setTimeout(this.hideReviewer2, 1000);
        },
        itemClickedReviewer2(index) {
            this.selectedReviewer2 = index;
            this.selectItemReviewer2();
        },
        selectItemReviewer2() {
            if (!this.matchesReviewer2.length) {
            return;
            }
            this.selectedItemReviewer2 = this.matchesReviewer2[this.selectedReviewer2];
            this.visibleReviewer2 = false;
            this.queryReviewer2 = this.selectedItemReviewer2.text
            this.idReviewer2 = this.selectedItemReviewer2.value
            if (this.shouldReset) {
            this.queryReviewer2 = '';
            this.selectedReviewer2 = 0;
            }
        },
        upReviewer2() {
            if (this.selectedReviewer2 == 0) {
            return;
            }
            this.selectedReviewer2 -= 1;
            this.scrollToItemReviewer2();
        },
        downReviewer2() {
            if (this.selectedReviewer2 >= this.matchesReviewer2.length - 1) {
            return;
            }
            this.selectedReviewer2 += 1;
            this.scrollToItemReviewer2();
        },
        scrollToItemReviewer2() {
            this.$refs.optionsList.scrollTop = this.selectedReviewer2 * this.itemHeight;
        },

        /**
         * SEARCH SELECT REVIEWER 3
         */
        getDataReviewer3(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    idPegawai: '',
                    limit: 10,
                    nama: this.queryReviewer3,
                    pageIn: 1
                }
            } else {
                payload = {
                    idPegawai: val,
                    limit: 10,
                    nama: '',
                    pageIn: 1
                }
            }
            DataApi.post("pegawai/get/jabatan", payload)
            .then(res => {
                this.dataReviewer3 = []
                let response = res.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i][0],
                        text: tempData[i][1]
                    }
                    this.dataReviewer3.push(onPush)
                }
                if(val != 'null') {
                    this.queryReviewer3 = this.dataReviewer3[0].text
                    this.idReviewer3 = this.dataReviewer3[0].value
                }
            })
        },
        toggleVisibleReviewer3() {
            this.visibleReviewer3 = true;
        },
        hideReviewer3() {
            this.visibleReviewer3 = false;
        },
        toggleCloseVisibleReviewer3() {
            setTimeout(this.hideReviewer3, 1000);
        },
        itemClickedReviewer3(index) {
            this.selectedReviewer3 = index;
            this.selectItemReviewer3();
        },
        selectItemReviewer3() {
            if (!this.matchesReviewer3.length) {
            return;
            }
            this.selectedItemReviewer3 = this.matchesReviewer3[this.selectedReviewer3];
            this.visibleReviewer3 = false;
            this.queryReviewer3 = this.selectedItemReviewer3.text
            this.idReviewer3 = this.selectedItemReviewer3.value
            if (this.shouldReset) {
            this.queryReviewer3 = '';
            this.selectedReviewer3 = 0;
            }
        },
        upReviewer3() {
            if (this.selectedReviewer3 == 0) {
            return;
            }
            this.selectedReviewer3 -= 1;
            this.scrollToItemReviewer3();
        },
        downReviewer3() {
            if (this.selectedReviewer3 >= this.matchesReviewer3.length - 1) {
            return;
            }
            this.selectedReviewer3 += 1;
            this.scrollToItemReviewer3();
        },
        scrollToItemReviewer3() {
            this.$refs.optionsList.scrollTop = this.selectedReviewer3 * this.itemHeight;
        },

        // LOAD FILE
        loadFile(e) {
            let files = document.getElementById('inputFile').files[0]
            this.file = files
            this.fileName = files.name
            this.fileSize = files.size
        },
        uploadFile() {
            this.$store.state.loadingScreen = true
            if (this.file != '') {
                let imageData = this.file

                const fd = new FormData()
                fd.append('file', imageData)

                DataApiUpload.post('upload', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlFile = response.data.path

                        let pushFile = {
                            createdDate: new Date(),
                            deskripsi: this.deskripsi,
                            fileName: this.fileName,
                            size: this.fileSize,
                            url: this.urlFile
                        }
                        this.tempFile.push(pushFile)
                        setTimeout(this.clearFile, 200);
                    } else {
                        alert('Upload Photo Failed !')
                    }
                    this.$store.state.loadingScreen = false
                });
            } else if(this.file == '') {
                this.$store.state.loadingScreen = false
                this.urlFile = ''
            }
        },
        removeFile() {
            this.file = ''
            this.fileName = ''
            this.fileSize = ''
        },
        clearFile() {
            this.deskripsi = ''
            this.fileName = ''
            this.fileSize = ''
            this.urlFile = ''
            this.file = ''
        },
        showFile(id) {
            let base = this.tempFile[id].url
            DataApiUpload.get('load/' + base)
            .then( res => {
                let openWindow = res.config.baseURL + res.config.url
                window.open(openWindow)
            })
        },
        deleteFile(id) {
            this.tempFile.splice(id, 1)
        },

        dispositionData(val) {
            let generate = this.datas[val]
            this.kodeSurat = generate.unix
            this.dispositionModal = true
        },
        getDataAksi() {
            let payload = {
                action: '',
                limit: 9999,
                pageIn: 1
            }
            DataApi.post("surat/action/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.dataAksi = response.data.data
                    var i 
                }
            })
        },

        /**
         * SEARCH PESERTA
         */
        getDataPeserta() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 4,
                nama: this.queryPeserta,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPeserta = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPeserta.push(onPush)
                }
            })
        },
        toggleVisiblePeserta() {
            this.visiblePeserta = true;
        },
        hidePeserta() {
            this.visiblePeserta = false;
        },
        toggleCloseVisiblePeserta() {
            setTimeout(this.hidePeserta, 1000);
        },
        itemClickedPeserta(index) {
            this.selectedPeserta = index;
            this.selectItemPeserta();
        },
        selectItemPeserta() {
            if (!this.matchesPeserta.length) {
            return;
            }
            this.selectedItemPeserta = this.matchesPeserta[this.selectedPeserta];
            this.visiblePeserta = false;
            this.queryPeserta = this.selectedItemPeserta.text
            this.idPeserta = this.selectedItemPeserta.value
            var i = 0
            let data = this.sumPeserta
            let push = ''
            if(data.length == 0) {
                push = {
                    nama: this.queryPeserta.split(" - ")[0],
                    id: this.idPeserta
                }
                this.sumPeserta.push(push)
                this.modalPeserta = false
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j].id == this.idPeserta) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    push = {
                        nama: this.queryPeserta.split(" - ")[0],
                        id: this.idPeserta
                    }
                    this.sumPeserta.push(push)
                    this.modalPeserta = false
                }
            }
            this.queryPeserta = ''
            this.idPeserta = ''
            if (this.shouldReset) {
            this.queryPeserta = '';
            this.selectedPeserta = 0;
            }
        },
        upPeserta() {
            if (this.selectedPeserta == 0) {
            return;
            }
            this.selectedPeserta -= 1;
            this.scrollToItemPeserta();
        },
        downPeserta() {
            if (this.selectedPeserta >= this.matchesPeserta.length - 1) {
            return;
            }
            this.selectedPeserta += 1;
            this.scrollToItemPeserta();
        },
        scrollToItemPeserta() {
            this.$refs.optionsList.scrollTop = this.selectedPeserta * this.itemHeight;
        },

        deleteSum(id) {
            this.sumPeserta.splice(id, 1)
        },
        goSaveDisposition() {
            this.errDisposition = ''
            let sumAksi = ''
            let sumPeserta = ''
            let dataAksi = this.dataAksi
            let dataPeserta = this.sumPeserta
            let payload = ''
            let gap = '##'
            var i = 0
            for(i=0;i<dataAksi.length;i++) {
                let id = dataAksi[i].unix
                let pushs = document.getElementById(id).checked
                if(pushs == true) {
                    if(sumAksi == '') {
                        sumAksi = id
                    } else {
                        sumAksi = sumAksi + gap + id
                    }
                }
            }
            if(dataPeserta.length != 0) {
                var j = 0
                for(j=0;j<dataPeserta.length;j++) {
                    let idPeg = dataPeserta[j].id
                    if(sumPeserta == '') {
                        sumPeserta = idPeg
                    } else {
                        sumPeserta = sumPeserta + gap + idPeg
                    }
                }
            }
            if(sumPeserta != '') {
                this.$store.state.loadingScreen = true
                payload = {
                    action: sumAksi,
                    kepada: sumPeserta,
                    kodeSurat: this.kodeSurat
                }
                DataApi.post("surat/disposisi/simpan", payload)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        if(response.data.Data1 == 'Y') {
                            this.success = true
                        } else {
                            this.success = false
                        }
                        this.alertMess = response.data.Data2
                    } else {
                        this.alertMess = response.message
                        this.success = false
                    }
                    this.getData()
                    this.dispositionModal = false
                    this.loading = false
                    this.currentAlertCounter = 7
                    this.$store.state.loadingScreen = false
                })
            } else {
                this.errDisposition = '*Harap melengkapi data.'
            }
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataAksi()
        this.getDataJenis()
        this.getDataMasalah()
        this.getDataTempat()
        this.getDataSearchMasalah()
        this.getDataSearchJenis()
        this.getDataLampiran()
        this.getDataSifat()
        this.getDataDari('null')
        this.getDataKepada()
        this.getDataReviewer1('null')
        this.getDataReviewer2('null')
        this.getDataReviewer3('null')
    },
    computed: {
        matchesDari() {
            if (this.queryDari == '') {
                return [];
            }
            return this.dataDari.filter((item) => item['text'].toLowerCase().includes(this.queryDari.toLowerCase()))
        },
        matchesKepada() {
            if (this.queryKepada == '') {
                return [];
            }
            return this.dataKepada.filter((item) => item.toLowerCase().includes(this.queryKepada.toLowerCase()))
        },
        matchesReviewer1() {
            if (this.queryReviewer1 == '') {
                return [];
            }
            return this.dataReviewer1.filter((item) => item['text'].toLowerCase().includes(this.queryReviewer1.toLowerCase()))
        },
        matchesReviewer2() {
            if (this.queryReviewer2 == '') {
                return [];
            }
            return this.dataReviewer2.filter((item) => item['text'].toLowerCase().includes(this.queryReviewer2.toLowerCase()))
        },
        matchesReviewer3() {
            if (this.queryReviewer3 == '') {
                return [];
            }
            return this.dataReviewer3.filter((item) => item['text'].toLowerCase().includes(this.queryReviewer3.toLowerCase()))
        },
        matchesPeserta() {
            if (this.queryPeserta == '') {
                return [];
            }
            return this.dataPeserta.filter((item) => item['text'].toLowerCase().includes(this.queryPeserta.toLowerCase()))
        },
    }
}
</script>
<style scoped>
::v-deep .ui.search.dropdown>.text {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
input[type="checkbox"] {
    width: 15px;
    height: 15px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete, .area-input textarea {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
::v-deep .nav-tabs .nav-item {
    flex-grow: 1;
    position: relative;
    background-color: transparent !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid rgba(224, 224, 224, 1) !important;
    border-radius: 0px;
}
::v-deep .nav-tabs .nav-link.active {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: transparent;
    background-color: white;
    border-bottom: 1px solid rgba(48, 107, 221, 1) !important;
    color: black;
    font-weight: bold;
}
.nav-tabs li a span {
    color: rgba(96, 96, 96, 1) !important;
    font-size: 12px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
input:disabled {
    background-color: whitesmoke;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 80%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item.is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
label{
	margin: 0;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
::v-deep .ui.search.dropdown>.text {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
</style>